module.exports = __webpack_public_path__ + "media/images/smart_phone/shares/202001/ins-be3500d62f2f1660af8f62527273d6a6.png";